import {QueueItemType} from "../../types";
import AuthorBadgeByUuid from "@/components/AuthorBadgeByUuid/AuthorBadgeByUuid";
import {AuthorBadgeVariant, Card} from "@varymadellc/my-weed-club-component-library";
import Link from "next/link";

export interface QueueItemImageProps {
    data: QueueItemType;
}

export default function QueueItemProfile({data}: QueueItemImageProps) {
    return (
        <Card className="w-full mx-auto p-4">
            <div className="flex flex-col sm:flex-row flex-wrap items-center gap-4 mx-auto">
                <div className="flex justify-end">
                    <AuthorBadgeByUuid className="flex-1 cursor-pointer" variant={'large' as AuthorBadgeVariant.large}
                                       uuid={data.metadata.uuid}/>
                </div>
                <div className="flex-1">
                    <Link className="text-left" href={data.metadata.url}>
                        <p>Here is a random member for you to check out.</p>
                        <p>It&apos;s important to interact with each other.</p>
                    </Link>
                </div>
            </div>
        </Card>
    );
}